import { Modal } from "antd";
import { useEffect, useState } from "react";
export const ModalNotification = () => {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = (e) => {
    localStorage.setItem("isShowModal","false")
    setOpen(false);
  };
  const handleCancel = (e) => {
    localStorage.setItem("isShowModal","false")
    setOpen(false);
  };
  useEffect(() => {
    let t = localStorage.getItem("isShowModal");
    if(t==="" || t===undefined || t==="true"){
      setOpen(true);
    }
  }, []);
  return (
    <>
      <a className="nav-link" href="#" onClick={showModal}>
        <i className="material-icons" style={{ fontSize: "30px" }}>
          info
        </i>
        <p className="sidebar-normal">Xem video hướng dẫn</p>
      </a>
      <Modal
        title="HƯỚNG DẪN TẠO ĐƠN HÀNG"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        height={500}
        okText="Đã hiểu!"
        cancelText="Đóng"
      >
        <iframe
          width="100%"
          height="500px"
          src="https://www.youtube.com/embed/mecoDg1eRJc?si=Bv0YFNJWO9zRpAWy"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </Modal>
    </>
  );
};
